module.exports = __webpack_public_path__ + "static/media/qrcode.7494922e.svg";